import IconButton from "../Button/IconButton";
import ArrowRightIcon from "../Icons/ArrowRightIcon";

type Direction = "prev" | "next";

interface Props {
	direction: Direction;
	isDisabled: boolean;
	onClick: () => void;
}

const VARIANTS: Record<Direction, { label: string; icon?: string }> = {
	prev: { label: "Предыдущая услуга", icon: "rotate-180" },
	next: { label: "Следующая услуга" },
};

export default function SliderArrow({ direction, isDisabled, onClick }: Props) {
	const { label, icon } = VARIANTS[direction];

	return (
		<IconButton
			icon={<ArrowRightIcon className={icon} />}
			label={label}
			disabled={isDisabled}
			onClick={onClick}
		/>
	);
}
